import { WithStyles, withStyles } from '@material-ui/styles'
import { bind } from 'bind-decorator'
import { appConfig } from 'config'
import { computed, observable } from 'mobx'
import { observer } from 'mobx-react'
import { ModulesAndComponentsLoader } from 'modules/ModulesLoader'
import * as React from 'react'
import { Portal } from 'react-portal'
import { menuStore } from 'stores/menuStore'
import { routerStore } from 'stores/routerStore'
import { sliderStore } from 'stores/sliderStore'
import { MenuStyles } from './menu.style'

type IMenuProps = WithStyles<typeof MenuStyles>

@observer
class MenuCls extends React.Component<IMenuProps> {
  @observable submenuOpen = false
  element = React.createRef<HTMLDivElement>()

  @bind
  closeMenu() {
    menuStore.closeMenu()
  }

  componentDidMount() {
    document.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape') this.closeMenu()
      },
      false
    )
  }

  componentWillUnmount() {
    document.removeEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape') this.closeMenu()
      },
      false
    )
  }

  getRootUrl = (url: string) => {
    const splitUrl = url.split('/').filter(Boolean)
    return splitUrl[0]
  }

  @computed
  get isExtraRoute() {
    const { extraRoutes } = appConfig
    const location = routerStore.location.pathname

    const found = extraRoutes.some((extraRoute) => {
      return (
        location.includes(extraRoute.path) ||
        this.getRootUrl(location).includes(this.getRootUrl(extraRoute.path))
      )
    })

    return found
  }

  render() {
    return (
      <Portal>
        {(sliderStore.showContent || this.isExtraRoute) && (
          <ModulesAndComponentsLoader
            moduleName={'Menu/menu'}
            isModule={true}
          />
        )}
      </Portal>
    )
  }
}

export default withStyles(MenuStyles, { name: 'Menu' })(MenuCls)
